<!-- 宽度由宿主白色面板固定 800，内部只占满宿主；窄屏由面板收缩自适应 -->
<div class="flex flex-col h-full min-h-0 relative w-full">
  <!-- 顶部统计标题栏 -->
  <div class="p-[16px] border-b-[0.5px] border-neutral-n5 shrink-0">
    @if (currentItem) {
      <div class="flex items-center justify-between">
        <!-- 左侧：标题类型 -->
        <div class="flex items-center gap-[8px]">
          <span class="font-medium text-[16px]">
            @switch (currentItem | messageItemKind) {
              @case ('question') {
                第{{ currentItem.no }}题
              }
              @case ('module') {
                模块反馈
              }
              @default {
                任务反馈
              }
            }
          </span>
        </div>
        <!-- 右侧：消息流筛选 + 圆形箭头(去原题) + 三个点下拉(批量删除)，与左栏筛选靠操作按钮的布局保持一致 -->
        <div class="flex items-center gap-[4px]">
          <!-- 「未回复」由后端按 unreplied 过滤 -->
          <nz-segmented
            nzSize="small"
            class="mr-[4px]"
            [(ngModel)]="messageFilter"
            (ngModelChange)="onMessageFilterChange($event)"
          >
            <label nz-segmented-item [nzValue]="ThreadMessageFilter.All">全部</label>
            <label nz-segmented-item [nzValue]="ThreadMessageFilter.Unreplied">未回复</label>
          </nz-segmented>

          <button nz-button nzType="text" nzSize="small" nz-dropdown [nzDropdownMenu]="menu">
            <i nz-icon nzType="ellipsis"></i>
          </button>
          <nz-dropdown-menu #menu="nzDropdownMenu">
            <ul nz-menu>
              <li nz-menu-item (click)="onBatchDelete()">批量删除</li>
            </ul>
          </nz-dropdown-menu>
          <!-- 去原题仅题目类型显示；任务/模块反馈不展示 -->
          @if ((currentItem | messageItemKind) === 'question') {
            <button nz-button nzType="text" (click)="goDetail()" nzSize="small">
              <div class="flex items-center">
                查看原题
                <lib-fl-icon name="icon-jiantou-you" class="ml-1"></lib-fl-icon>
              </div>
            </button>
          }
        </div>
      </div>
    }
  </div>

  <div class="flex flex-1 min-h-0 gap-2">
    <!-- 主区：消息流 + 底部提示 -->
    <div class="flex-1 min-w-0 flex flex-col space-y-2">
      <div class="relative flex-1 min-h-0">
        @if (loading) {
          <div class="h-full flex items-center justify-center">
            <nz-spin nzSize="default"></nz-spin>
          </div>
        } @else if (threadQuery) {
          <fl-message-list
            #messageList
            [threadQuery]="threadQuery"
            [refreshTick]="refreshTick"
            [selectable]="true"
            [unreplied]="messageFilter === ThreadMessageFilter.Unreplied"
            [replyMessageId]="replyTarget?.msgId ?? null"
            (messagesChange)="onMessagesChanged($event)"
            (avatarClick)="onAvatarClick($event)"
            (threadOpened)="onThreadOpened($event)"
          ></fl-message-list>
        } @else {
          <div class="h-full flex items-center justify-center text-neutral-n4">暂无消息</div>
        }
      </div>

      <!-- 底部回复区：进入批量选择时隐藏，避免与底部悬浮批量条重叠 -->
      @if (!messageList?.selectionMode) {
        <div class="shrink-0 p-4">
          <fl-reply-composer
            [replyTarget]="replyTarget ?? {}"
            [clearTick]="clearCount"
            [quote]="{}"
            [upload]="{ scope: 'blackboard', extra: { taskId: taskId() } }"
            (send)="onSendReply($event)"
            (cancel)="onCancelReply()"
          >
            <!-- 「全班可见」勾选：由宿主通过插槽注入并自持状态。回复全班时恒勾选，仅作提示
                 （CreateMessageBody 无 toAll 字段，本就必须全班可见）。
                 不用 disabled/pointer-events-none：前者把蓝色勾选置灰，后者点击穿透会让输入框失焦收起 -->
            <label
              class="flex select-none items-center gap-[6px] text-[13px] text-neutral-n2"
              [class.cursor-pointer]="!!replyTarget?.msgId"
              [class.cursor-not-allowed]="!replyTarget?.msgId"
              (mousedown)="$event.preventDefault()"
              (click)="onToAllClick($event)"
              toAll
            >
              <input
                type="checkbox"
                name="replyToAll"
                [ngModel]="replyTarget?.msgId ? toAll : true"
                (ngModelChange)="toAll = $event"
                class="accent-[var(--color-primary-b1)]"
              />
              全班可见
            </label>
          </fl-reply-composer>
        </div>
      }
      <!-- 批量选择条：进入选择模式时占据文档流，flex 自动为消息流腾出高度，避免遮挡最后一条消息 -->
      @if (messageList?.selectionMode) {
        <div
          class="shrink-0 flex items-center justify-between px-[16px] py-[10px] border-t-[0.5px] border-neutral-n5 bg-white"
        >
          <label class="flex items-center gap-[8px] text-[13px] text-neutral-n2 cursor-pointer">
            <input
              type="checkbox"
              class="w-[16px] h-[16px] accent-[var(--color-primary-b1)]"
              [checked]="messageList.allSelected"
              (click)="messageList.toggleSelectAll()"
            />
            共 <span class="text-primary mx-[2px]">{{ messageList.selectedIds.size }}</span> 条
          </label>
          <div class="flex items-center gap-[8px]">
            <button nz-button nzType="text" (click)="messageList.exitSelectionMode()">取消</button>
            <button nz-button nzType="primary" [nz-popconfirm]="deleteTitle" (nzOnConfirm)="deleteSelection()">
              删除
            </button>
          </div>
        </div>
      }
    </div>
  </div>
</div>
